module.exports = __webpack_public_path__ + "img/21_58.f8faad49.png";